const getApiErrorMessages = (err, type = "entries") =>
  (err.response &&
    err.response.data &&
    ((err.response.data.errors && Object[type](err.response.data.errors)) ||
      err.response.data.message)) ||
  err.message ||
  'Unknown error';

export default getApiErrorMessages;
